var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 256
  }), /*#__PURE__*/React.createElement("rect", {
    y: 256,
    style: {
      fill: "#82AFFF"
    },
    width: 512,
    height: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M257.251,365.865c-2.282-0.099-56.154-2.855-83.191-39.897  c-15.757-21.584-18.901-50.296-9.346-85.332l3.861,1.052c-9.216,33.796-6.288,61.351,8.706,81.904  c25.883,35.484,79.604,38.251,80.146,38.272L257.251,365.865z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M164.675,225.101c-2.657,6.919-2.05,14.163,1.025,19.657c5.961-2.024,11.26-7.001,13.916-13.92   c2.657-6.919,2.05-14.163-1.025-19.657C172.63,213.204,167.332,218.181,164.675,225.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M198.421,320.752c-2.948,4.864-3.722,11.386-1.538,17.717c2.04,5.916,6.249,10.281,11.128,12.482   c-4.74-2.483-10.768-3.106-16.682-1.067c-6.331,2.183-10.99,6.812-13.003,12.132c4.864,2.948,11.386,3.722,17.717,1.538   c6.331-2.183,10.99-6.812,13.003-12.132l-0.007-0.003c2.924-4.859,3.69-11.355,1.514-17.664   C208.37,327.425,203.741,322.765,198.421,320.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M186.883,303.095c-4.549,3.414-7.699,9.177-8.034,15.866c-0.313,6.25,1.965,11.869,5.671,15.731   c-3.472-4.072-8.833-6.897-15.081-7.21c-6.689-0.335-12.737,2.223-16.589,6.408c3.414,4.549,9.177,7.699,15.866,8.034   s12.737-2.223,16.589-6.408c-0.002-0.002-0.003-0.003-0.003-0.003c4.523-3.421,7.656-9.162,7.989-15.828   C193.627,312.996,191.069,306.946,186.883,303.095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M181.895,283.189c-5.501,1.444-10.593,5.593-13.427,11.661c-2.649,5.67-2.66,11.733-0.685,16.708   c-1.679-5.081-5.577-9.721-11.245-12.368c-6.068-2.834-12.634-2.749-17.781-0.326c1.445,5.501,5.593,10.593,11.661,13.427   s12.634,2.749,17.781,0.326c0,0-0.002-0.004-0.003-0.007c5.48-1.458,10.549-5.593,13.373-11.639   C184.403,294.903,184.318,288.336,181.895,283.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M184.724,263.436c-5.66-0.563-11.878,1.552-16.649,6.252c-4.458,4.392-6.581,10.071-6.463,15.422   c0.197-5.348-1.841-11.055-6.231-15.511c-4.7-4.771-10.885-6.978-16.553-6.501c-0.563,5.66,1.552,11.878,6.252,16.649   s10.885,6.978,16.553,6.501c0,0,0-0.005,0-0.008c5.645,0.543,11.836-1.567,16.591-6.251   C182.994,275.289,185.202,269.104,184.724,263.436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M188.726,244.635c-5.489-1.492-11.971-0.435-17.454,3.41c-5.124,3.593-8.157,8.843-8.926,14.14   c1.079-5.241,0.014-11.207-3.578-16.329c-3.845-5.483-9.58-8.684-15.249-9.151c-1.491,5.489-0.435,11.971,3.41,17.454   s9.58,8.684,15.249,9.151c0.001-0.003,0.001-0.005,0.001-0.005c5.477,1.466,11.933,0.41,17.397-3.422   C185.058,256.038,188.26,250.303,188.726,244.635z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M193.66,345.719c2.71,4.213-1.771,8.694-5.983,5.983c-0.279-0.18-0.522-0.423-0.702-0.702   c-2.71-4.213,1.771-8.694,5.983-5.983C193.237,345.197,193.481,345.44,193.66,345.719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M212.832,348.053c2.71,4.213-1.771,8.694-5.983,5.983c-0.279-0.18-0.522-0.423-0.702-0.702   c-2.71-4.213,1.771-8.694,5.983-5.983C212.41,347.531,212.653,347.774,212.832,348.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M182.657,314.21c2.71,4.213-1.771,8.694-5.983,5.983c-0.279-0.18-0.522-0.423-0.702-0.702   c-2.71-4.213,1.771-8.694,5.983-5.983C182.234,313.688,182.477,313.931,182.657,314.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M156.149,282.867c2.71,4.213-1.771,8.694-5.983,5.983c-0.279-0.18-0.522-0.423-0.702-0.702   c-2.71-4.213,1.771-8.694,5.983-5.983C155.726,282.345,155.97,282.588,156.149,282.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M174.655,261.639c2.71,4.213-1.771,8.694-5.983,5.983c-0.279-0.18-0.522-0.423-0.702-0.702   c-2.71-4.213,1.771-8.694,5.983-5.983C174.232,261.117,174.475,261.36,174.655,261.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M167.639,239.889c2.71,4.213-1.771,8.694-5.983,5.983c-0.279-0.18-0.522-0.423-0.702-0.702   c-2.71-4.213,1.771-8.694,5.983-5.983C167.217,239.366,167.46,239.61,167.639,239.889z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M257.423,365.865l-0.175-4.001c0.542-0.021,54.263-2.787,80.146-38.272  c14.994-20.553,17.922-48.108,8.706-81.904l3.861-1.052c9.555,35.036,6.411,63.748-9.346,85.332  C313.577,363.01,259.705,365.766,257.423,365.865z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M349.999,225.101c2.657,6.919,2.05,14.163-1.025,19.657c-5.961-2.024-11.26-7.001-13.916-13.92   c-2.657-6.919-2.05-14.163,1.025-19.657C342.044,213.204,347.343,218.181,349.999,225.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M316.253,320.752c2.948,4.864,3.722,11.386,1.538,17.717c-2.04,5.916-6.249,10.281-11.128,12.482   c4.74-2.483,10.768-3.106,16.682-1.067c6.331,2.183,10.99,6.812,13.003,12.132c-4.864,2.948-11.386,3.722-17.717,1.538   s-10.99-6.812-13.003-12.132c0.002-0.001,0.004-0.002,0.004-0.002c-2.921-4.86-3.687-11.356-1.511-17.665   C306.305,327.425,310.934,322.765,316.253,320.752z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M327.791,303.095c4.549,3.414,7.699,9.177,8.034,15.866c0.313,6.25-1.965,11.869-5.671,15.731   c3.472-4.072,8.833-6.897,15.081-7.21c6.689-0.335,12.737,2.223,16.589,6.408c-3.414,4.549-9.177,7.699-15.866,8.034   s-12.737-2.223-16.589-6.408c0.002-0.002,0.003-0.003,0.003-0.003c-4.523-3.421-7.656-9.162-7.989-15.828   C321.048,312.996,323.605,306.946,327.791,303.095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M332.779,283.189c5.501,1.444,10.593,5.593,13.427,11.661c2.649,5.67,2.66,11.733,0.685,16.708   c1.679-5.081,5.577-9.721,11.245-12.368c6.068-2.834,12.634-2.749,17.781-0.326c-1.445,5.501-5.593,10.593-11.661,13.427   s-12.634,2.749-17.781,0.326c0,0,0.002-0.004,0.003-0.007c-5.48-1.458-10.548-5.593-13.373-11.639   C330.271,294.903,330.357,288.336,332.779,283.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M329.95,263.436c5.66-0.563,11.878,1.552,16.649,6.252c4.458,4.392,6.581,10.071,6.463,15.422   c-0.197-5.348,1.841-11.055,6.231-15.511c4.7-4.771,10.885-6.978,16.553-6.501c0.563,5.66-1.552,11.878-6.252,16.649   s-10.885,6.978-16.553,6.501c0,0,0-0.005,0-0.008c-5.645,0.543-11.836-1.567-16.591-6.251   C331.68,275.289,329.472,269.104,329.95,263.436z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M325.948,244.635c5.489-1.492,11.971-0.435,17.454,3.41c5.124,3.593,8.157,8.843,8.926,14.14   c-1.079-5.241-0.014-11.207,3.578-16.329c3.846-5.483,9.58-8.684,15.249-9.151c1.491,5.489,0.435,11.971-3.41,17.454   s-9.58,8.684-15.249,9.151c-0.001-0.003-0.001-0.005-0.001-0.005c-5.477,1.466-11.933,0.41-17.397-3.422   C329.616,256.038,326.415,250.303,325.948,244.635z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M321.014,345.719c-2.71,4.213,1.771,8.694,5.983,5.983c0.279-0.18,0.522-0.423,0.702-0.702   c2.71-4.213-1.771-8.694-5.983-5.983C321.437,345.197,321.194,345.44,321.014,345.719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M301.842,348.053c-2.71,4.213,1.771,8.694,5.983,5.983c0.279-0.18,0.522-0.423,0.702-0.702   c2.71-4.213-1.771-8.694-5.983-5.983C302.265,347.531,302.021,347.774,301.842,348.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M332.017,314.21c-2.71,4.213,1.771,8.694,5.983,5.983c0.279-0.18,0.522-0.423,0.702-0.702   c2.71-4.213-1.771-8.694-5.983-5.983C332.44,313.688,332.197,313.931,332.017,314.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M358.525,282.867c-2.71,4.213,1.771,8.694,5.983,5.983c0.279-0.18,0.522-0.423,0.702-0.702   c2.71-4.213-1.771-8.694-5.983-5.983C358.948,282.345,358.705,282.588,358.525,282.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M340.02,261.639c-2.71,4.213,1.771,8.694,5.983,5.983c0.279-0.18,0.522-0.423,0.702-0.702   c2.71-4.213-1.771-8.694-5.983-5.983C340.443,261.117,340.199,261.36,340.02,261.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M347.035,239.889c-2.71,4.213,1.771,8.694,5.983,5.983c0.279-0.18,0.522-0.423,0.702-0.702   c2.71-4.213-1.771-8.694-5.983-5.983C347.458,239.366,347.214,239.61,347.035,239.889z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CD7FF"
    },
    d: "M280.799,225.845h-47.812c-14.883,0-26.947,12.064-26.947,26.947v42.118  c0,14.885,12.064,26.947,26.947,26.947h47.812c14.882,0,26.947-12.063,26.947-26.947v-42.118  C307.746,237.91,295.681,225.845,280.799,225.845z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "264.782,262.501 264.782,267.836 259.447,267.836 259.447,262.501 255.339,262.501    255.339,267.836 250.004,267.836 250.004,262.501 246.667,262.501 246.667,273.171 249.335,276.55 249.335,315.85 265.339,315.85    265.339,276.55 268.007,273.171 268.007,262.501  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M258.115,245.607c2.64-1.278,3.334,4.113,3.334,4.113c5.557-2.779,4.107-7.289,2.779-9.447   c-1.779-2.89-8.892-4.001-11.892,2.001c-3.001,6.002,5.112,17.895,5.112,17.895C257.893,256.5,254.67,247.276,258.115,245.607z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "292.206,272.449 292.206,277.784 286.871,277.784 286.871,272.449 282.764,272.449    282.764,277.784 277.429,277.784 277.429,272.449 274.092,272.449 274.092,283.119 276.759,286.497 276.759,325.798    292.764,325.798 292.764,286.497 295.432,283.119 295.432,272.449  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M285.54,255.554c2.64-1.278,3.334,4.113,3.334,4.113c5.557-2.779,4.107-7.289,2.779-9.447   c-1.779-2.89-8.892-4.001-11.892,2.001c-3,6.002,5.112,17.895,5.112,17.895C285.318,266.447,282.095,257.223,285.54,255.554z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "237.357,272.449 237.357,277.784 232.022,277.784 232.022,272.449 227.914,272.449    227.914,277.784 222.58,277.784 222.58,272.449 219.243,272.449 219.243,283.119 221.91,286.497 221.91,325.798 237.915,325.798    237.915,286.497 240.582,283.119 240.582,272.449  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M230.69,255.554c2.64-1.278,3.334,4.113,3.334,4.113c5.557-2.779,4.107-7.289,2.779-9.447   c-1.779-2.89-8.892-4.001-11.892,2.001c-3.001,6.002,5.113,17.895,5.113,17.895C230.468,266.447,227.245,257.223,230.69,255.554z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6EC86E"
    },
    d: "M301.109,318.695c-3.562-1.762-7.519-2.845-11.762-2.845c-4.548,0-8.763,1.244-12.51,3.251  c-4.872-5.25-11.773-8.586-19.5-8.586c-7.727,0-14.628,3.336-19.5,8.586c-3.747-2.007-7.962-3.251-12.51-3.251  c-4.243,0-8.2,1.082-11.762,2.845c7.616,13.969,22.202,36.542,43.772,45.169C278.907,355.237,293.493,332.664,301.109,318.695z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M257.097,139.919l0.24-0.12C257.337,139.799,257.257,139.82,257.097,139.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M257.337,139.799l0.24,0.12C257.417,139.82,257.337,139.799,257.337,139.799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M308.519,162.639c-1.5-8.669-12.67-10.17-25.507-11.003c-12.837-0.834-18.339-8.169-18.339-8.169   h-14.671c0,0-5.502,7.335-18.339,8.169s-24.007,2.334-25.507,11.003s9.503,22.34,9.503,22.34l9.669-7.836   c0,0-11.837-11.337-6.002-15.505c5.762-4.116,22.562-1.265,30.045-11.146c-0.317,2.064-0.205,4.615,1.075,7.756   c2.445,6.002,1.556,13.56,1.556,13.56h5.335h5.335c0,0-0.889-7.558,1.556-13.56c1.28-3.142,1.392-5.692,1.075-7.756   c7.483,9.882,24.283,7.031,30.045,11.146c5.835,4.168-6.002,15.505-6.002,15.505l9.669,7.836   C299.016,184.979,310.019,171.308,308.519,162.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M262.783,113.458h-2.778v-3.001c0-1.473-1.194-2.667-2.667-2.667c-1.473,0-2.667,1.194-2.667,2.667   v3.001h-2.89c-1.473,0-2.667,1.194-2.667,2.667s1.194,2.667,2.667,2.667h2.89v7.669c0,1.473,1.194,2.667,2.667,2.667   c1.473,0,2.667-1.194,2.667-2.667v-7.669h2.778c1.473,0,2.667-1.194,2.667-2.667C265.45,114.652,264.256,113.458,262.783,113.458z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF0E1"
    },
    d: "M261.596,125.718c3.518,5.412-2.258,11.188-7.67,7.67c-0.337-0.219-0.628-0.511-0.847-0.847  c-3.518-5.412,2.258-11.188,7.67-7.67C261.085,125.089,261.377,125.381,261.596,125.718z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC75A"
    },
    d: "M219.104,236.494c2.149,1.073,4.659,2.001,7.224,2.001c8.839,0,13.171-4.998,13.171-13.837   s-5.332-15.505-14.171-15.505c0,0-0.997,0.017-2.594,0.262c-0.343,0.056-0.684,0.107-1.02,0.184   c-8.496,1.62-29.496,9.451-33.731,47.569c-5.921,53.287,37.344,101.363,69.354,112.033v-5.335   C257.337,363.864,181.759,306.07,219.104,236.494z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC75A"
    },
    points: "225.328,214.487 257.337,225.157 225.328,235.827  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "289.346,235.827 257.337,225.157 289.346,214.487  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M193.286,257.756c3.822-34.399,21.853-41.473,29.621-42.958c0.17-0.039,0.343-0.063,0.636-0.111   c0.976-0.15,1.651-0.191,1.86-0.2c5.849,0.041,9.705,4.446,9.705,9.781c0,5.883-3.445,8.113-6.891,8.225   c0,0,2.779-5.779-2.89-7.335c-3.826-1.05-8.669,2.001-8.225,7.558c0.312,3.905,4.019,7.669,8.225,7.669   c8.839,0,16.005-6.387,16.005-15.227s-7.166-16.005-16.005-16.005c0,0-0.997,0.017-2.594,0.262   c-0.343,0.056-0.684,0.107-1.02,0.184c-8.496,1.62-29.496,9.451-33.731,47.569c-5.921,53.287,37.344,101.363,69.354,112.033v-5.335   c0,0-11.337-5.668-19.087-11.174C214.304,335.677,188.963,296.662,193.286,257.756z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC75A"
    },
    d: "M295.57,236.494c-2.149,1.073-4.659,2.001-7.224,2.001c-8.839,0-13.171-4.998-13.171-13.837   s5.332-15.505,14.171-15.505c0,0,0.997,0.017,2.594,0.262c0.343,0.056,0.684,0.107,1.02,0.184   c8.496,1.62,29.496,9.451,33.731,47.569c5.921,53.287-37.344,101.363-69.354,112.033v-5.335   C257.337,363.864,332.915,306.07,295.57,236.494z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC75A"
    },
    points: "289.346,214.487 257.337,225.157 289.346,235.827  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M321.388,257.756c-3.822-34.399-21.853-41.473-29.621-42.958c-0.17-0.039-0.343-0.063-0.636-0.111   c-0.976-0.15-1.651-0.191-1.86-0.2c-5.849,0.041-9.705,4.446-9.705,9.781c0,5.883,3.445,8.113,6.891,8.225   c0,0-2.779-5.779,2.89-7.335c3.826-1.05,8.669,2.001,8.225,7.558c-0.312,3.905-4.019,7.669-8.225,7.669   c-8.839,0-16.005-6.387-16.005-15.227s7.165-16.005,16.005-16.005c0,0,0.997,0.017,2.594,0.262c0.343,0.056,0.684,0.107,1.02,0.184   c8.496,1.62,29.496,9.451,33.731,47.569c5.921,53.287-37.344,101.363-69.354,112.033v-5.335c0,0,11.337-5.668,19.087-11.174   C300.37,335.677,325.711,296.662,321.388,257.756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M261.596,221.746c3.518,5.412-2.258,11.188-7.67,7.67c-0.337-0.219-0.628-0.511-0.847-0.847   c-3.518-5.412,2.258-11.188,7.67-7.67C261.085,221.118,261.377,221.409,261.596,221.746z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC75A"
    },
    d: "M295.432,182.311c1.417-3.668-0.5-8.586-0.5-8.586c-4.918-0.167-8.336,3.418-8.336,3.418  c0.417-4.418-1.5-8.419-1.5-8.419c-6.335,0.75-8.419,4.501-8.419,4.501c-0.333-6.919-4.501-9.753-4.501-9.753  c-5.502,1.667-7.169,7.669-7.169,7.669c-0.834-6.835-7.669-10.003-7.669-10.003s-6.835,3.168-7.669,10.003  c0,0-1.667-6.002-7.169-7.669c0,0-4.168,2.834-4.501,9.753c0,0-2.084-3.751-8.419-4.501c0,0-1.917,4.001-1.5,8.419  c0,0-3.418-3.584-8.336-3.418c0,0-1.917,4.918-0.5,8.586c0,0-5.585-1.751-10.17,0.917c0,0,8.405,3.251,11.204,7.252h74.119  c2.8-4.001,11.204-7.252,11.204-7.252C301.017,180.561,295.432,182.311,295.432,182.311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M294.397,190.48c0,2.401-5.609,9.821-5.609,9.821s-18.185,2.532-31.451,2.532  c-13.352,0-31.578-2.6-31.578-2.6s-5.482-7.381-5.482-9.753c0-6.822,16.592-12.353,37.06-12.353  C277.805,178.127,294.397,183.658,294.397,190.48z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFC75A"
    },
    cx: 257.34,
    cy: 198.48,
    rx: 32.01,
    ry: 10.67
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC75A"
    },
    d: "M265.173,139.299c0-3.501-2.612-7.947-7.836-4.835c-5.224-3.112-7.836,1.334-7.836,4.835   S245.5,143.3,245,142.966c0,0,3.334,4.335,7.169,1.5c0,0,2.056,3.001,5.168,3.001s5.168-3.001,5.168-3.001   c3.834,2.834,7.169-1.5,7.169-1.5C269.174,143.3,265.173,142.8,265.173,139.299z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M246.665,397.874c-0.3,0-0.604-0.068-0.891-0.214c-0.99-0.49-1.391-1.693-0.896-2.683l10.67-21.34   c0.495-0.979,1.696-1.391,2.683-0.891c0.99,0.49,1.391,1.693,0.896,2.683l-10.67,21.34   C248.105,397.468,247.399,397.874,246.665,397.874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M268.009,397.874c-0.735,0-1.441-0.406-1.792-1.104l-10.67-21.34   c-0.495-0.99-0.094-2.193,0.896-2.683c0.985-0.505,2.188-0.094,2.683,0.891l10.67,21.34c0.495,0.99,0.094,2.193-0.896,2.683   C268.614,397.807,268.309,397.874,268.009,397.874z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M305.351,379.202c-31.619,7.068-64.409,7.068-96.028,0c0-5.335,0-15.321,0-20.656   c31.619,7.068,64.409,7.068,96.028,0C305.351,363.881,305.351,373.867,305.351,379.202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M235.775,371.425c-20.418,3.939-41.342,5.021-62.162,3.075c0.35,2.75,16.816,10.926,16.816,10.926   s-14.528,7.022-14.204,9.564c19.932,1.863,39.963,0.974,59.551-2.56L235.775,371.425L235.775,371.425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M278.977,371.425c20.418,3.939,41.342,5.021,62.162,3.075c-0.35,2.75-16.816,10.926-16.816,10.926   s14.528,7.022,14.204,9.564c-19.932,1.863-39.963,0.974-59.551-2.56v-21.005H278.977z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSm);
export default __webpack_public_path__ + "static/media/sm.6330810dfe1638ea5e0150df7fa6b9f4.svg";
export { ForwardRef as ReactComponent };